<template>
  <div class="dialog-wechat-qrcode-editor">
    <el-dialog
      width="50%"
      :title="`添加微信关注二维码（${dev.sn- dev.title}）`"
      :visible="visible"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form
        ref="form"
        label-position="top"
        :rules="formRule"
        :model="formData">

        <el-form-item label="微信公众号 App ID" prop="appId">
          <el-input
            placeholder="请输入微信公众号 App ID"
            v-model="formData.appId"
            disabled>
          </el-input>
        </el-form-item>

        <el-form-item label="货架（0为购物车的所有货架）" prop="qrcode.channelRoad">
          <el-input
            type="number"
            placeholder="请输入需要生成的设备货架号"
            v-model="formData.qrcode.channelRoad">
          </el-input>
        </el-form-item>

        <el-form-item label="设备类型" prop="qrcode.devType">
          <el-select v-model="formData.qrcode.devType" placeholder="请选择设备类型">
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="购买模式" prop="qrcode.buyMode">
          <el-select v-model="formData.qrcode.buyMode" placeholder="请选择购买模式">
            <el-option label="购买" value="b"></el-option>
            <el-option label="游戏" value="g"></el-option>
            <el-option label="游戏与购买" value="bg"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关注后动作" prop="qrcode.subAction">
          <el-select
            v-model="formData.qrcode.subAction"
            placeholder="请选择关注后动作"
            @change="onSubActionChange">
            <el-option label="不做动作" value="not"></el-option>
            <el-option label="优惠券" value="coupon"></el-option>
            <el-option label="兑换券" value="gift"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="优惠券"
          prop="qrcode.subExtend"
          v-if="formData.qrcode.subAction === 'coupon'">
          <el-select
            v-model="formData.qrcode.subExtend"
            placeholder="请选择关注后赠送的优惠券">
            <el-option
              v-for="coupon in couponList"
              :key="coupon.coupon_id"
              :label="coupon.coupon_name"
              :value="coupon.coupon_id"/>
          </el-select>
        </el-form-item>

        <el-form-item label="二维码类型" prop="qrcode.actionName">
          <el-select v-model="formData.qrcode.actionName" placeholder="请选择二维码类型">
            <el-option label="临时二维码" value="QR_STR_SCENE"></el-option>
            <el-option label="永久二维码" value="QR_LIMIT_STR_SCENE"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="二维码过期时间(单位:秒)，最大不超过2592000（即30天）"
          prop="qrcode.expireSeconds"
          v-if="formData.qrcode.actionName === 'QR_STR_SCENE'">
          <el-input
            type="number"
            placeholder="请输入二维码过期时间"
            v-model="formData.qrcode.expireSeconds">
          </el-input>
        </el-form-item>

        <el-form-item label="前 n 位用户可兑换（0代表不做限制）" prop="qrcode.exchangeLimit">
          <el-input
            type="number"
            placeholder="请输入需要生成的设备货架号"
            v-model="formData.qrcode.exchangeLimit">
          </el-input>
        </el-form-item>
      </el-form>

      <div class="submit-box">
        <el-button
          type="danger"
          @click="onFormSubmit">确定</el-button>
        <el-button @click="onFormCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wechatAccountApi from '@/api/wechatAccountApi'
import activityApi from '@/api/activityApi'

export default {
  name: 'DialogWechatQrcodeEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    dev: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      formData: {
        appId: '',
        sn: '',
        qrcode: {
          channelRoad: '0',
          devType: 'gpm',
          buyMode: 'b',
          subAction: 'not',
          subExtend: '',
          actionName: 'QR_STR_SCENE',
          expireSeconds: 86400,
          exchangeLimit: 0
        }
      },
      formRule: {
        appId: [
          { required: true, message: '请输入公众号 App ID', trigger: 'blur' }
        ],
        qrcode: {
          channelRoad: [
            { required: true, message: '请输入公众号名称', trigger: 'blur' }
          ]
        }
      },
      couponList: []
    }
  },
  methods: {
    onDialogOpen () {
      // this.getWechatAccount()
      this.formData.sn = this.dev.sn
      this.formData.appId = this.dev.appId
    },
    onDialogClose () {
      this.$emit('change', false)
    },
    onSubActionChange (option) {
      this.formData.qrcode.subExtend = ''
      if (option === 'coupon') {
        this.listCoupon()
      }
    },

    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()

        this.$emit('submit', this.formData)
        this.$emit('change', false)
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.$emit('change', false)
    },

    async getWechatAccount () {
      // Get wechat account
      try {
        const { rcode, data } = await wechatAccountApi.getWechatAccountByUserId(this.dev.userid)
        if (rcode === 701) {
          this.$message({
            message: '当前设备所属商户没有公众号配置',
            type: 'error'
          })
          this.$emit('change', false)
          return
        }

        this.formData.appId = data['app_id']
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取商户公众号配置失败',
          type: 'error'
        })
      }
    },
    async listCoupon () {
      try {
        const { rcode, msg, data } = await activityApi.listCoupon({
          page: 1,
          pageSize: 500,
          filters: {
            user_id: this.dev.userid
          }
        })
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
        }
        this.couponList = data.list
        if (data.list.length > 0) {
          this.formData.qrcode.subExtend = data.list[0].coupon_id
        }
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取优惠券列表失败',
          type: 'error'
        })
      }
    },
    async listGift () {
      try {
        const { rcode, msg, data } = await activityApi.listGift({
          page: 1,
          pageSize: 500,
          filters: {
            user_id: this.dev.userid
          }
        })
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
        }
        this.giftList = data.list
        if (data.list.length > 0) {
          this.formData.qrcode.subExtend = data.list[0].gift_id
        }
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取兑换券列表失败',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wechat-qrcode-editor {

  .submit-box {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogWechatQrcodeEditor.vue